var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0447 0C4.52469 0 0.0546875 4.48 0.0546875 10C0.0546875 15.52 4.52469 20 10.0447 20C15.5747 20 20.0547 15.52 20.0547 10C20.0547 4.48 15.5747 0 10.0447 0ZM10.0547 18C5.63469 18 2.05469 14.42 2.05469 10C2.05469 5.58 5.63469 2 10.0547 2C14.4747 2 18.0547 5.58 18.0547 10C18.0547 14.42 14.4747 18 10.0547 18Z",
    fill: "#F9FCFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5547 5H9.05469V11L14.3047 14.15L15.0547 12.92L10.5547 10.25V5Z",
    fill: "#F9FCFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.8a3d6e33dbc45225b9b894f6c82ca222.svg";
export { ForwardRef as ReactComponent };